<template>
  <div :id="containerId" v-if="downloaded" />
  <div class="placeholder" v-else>
    Loading...
  </div>
</template>

<script>
export default {
  name: 'Game',
  data() {
    return {
      downloaded: false,
      gameInstance: null,
      containerId: 'game-container'
    }
  },
  async mounted() {
    //this will be an arg passed in based on what demo the user clicks
    const game = await import(/* webpackChunkName: "game" */ '@/phaser/movement')
    this.downloaded = true
    this.$nextTick(() => {
      this.gameInstance = game.launch(this.containerId)
    })
  },
  destroyed() {
    this.gameInstance.destroy(false)
  }
}
</script>


<style lang="scss" scoped>
.placeholder {
  font-size: 2rem;
  font-family: 'Courier New', Courier, monospace;
}
</style>